<script setup lang="ts">
import Reserve from './reserve.vue';
import ReserveFlow from './reserve-flow.vue';

const autoReserveStore = useAutoReserveStore();
const route = useRoute();

const newAutoReserve = computed(
    () =>
        route.path.includes('/reserve/auto-reserve') ||
        (autoReserveStore.isAutoReserve && !autoReserveStore.oldFlowEnabled)
);
const currentModule = useCurrentItineraryModule();
const metaTagTitle = computed(() => {
    if (autoReserveStore.isAutoReserve) {
        return currentModule.value.metaTagTitle.replace('خرید', 'رزرو خودکار');
    }
    return currentModule.value.metaTagTitle;
});
useSeoMeta({
    title: metaTagTitle,
    ogTitle: metaTagTitle,
});
</script>

<template>
    <component :is="newAutoReserve ? ReserveFlow : Reserve">
        <NuxtPage />
    </component>
</template>
